<template>
    <div>
        <div class="row margin-top-10">
            <div class="col-md-12 wrap-page">
                <div class="full-width"
                    v-if="dataDetailExcercise.typeUploadExcercise == 5 || dataDetailExcercise.typeUploadExcercise == 6">
                    <embed :src="apiUrl + dataDetailExcercise.path" class="ember-pdf" />
                </div>
                <div
                    v-if="dataDetailExcercise.typeUploadExcercise == 1 || dataDetailExcercise.typeUploadExcercise == 2">
                    <div class="item-question-answer"
                        v-for="(dataSource, indexQuestion) of dataDetailExcercise.listExcerciseQuestionClassSchool"
                        :key="indexQuestion">
                        <PreviewQuestion :id="`question_${indexQuestion}`" :dataSource="dataSource.question"
                            :location="indexQuestion" :questions="dataSource.question.answers"
                            :isDontShowResultSaved="false" />
                    </div>
                </div>
                <div
                    v-else-if="dataDetailExcercise.typeUploadExcercise == 3 || dataDetailExcercise.typeUploadExcercise == 4">
                    <div class="item-question-answer"
                        v-for="(dataSource, indexQuestion) of dataDetailExcercise.listExcerciseQuestionClassSchool"
                        :key="indexQuestion">
                        <div v-if="dataSource.questionId > 0">

                            <PreviewQuestion :id="`question_${indexQuestion}`" :dataSource="dataSource"
                                :location="indexQuestion" :questions="dataSource.answers"
                                :isDontShowResultSaved="false" />
                        </div>
                        <div v-else>
                            <div class="question" v-html="dataSource.content">

                            </div>
                            <div v-for="(item, indexanswers) of dataSource.answers" :key="indexanswers">
                                <MultipleChoiceNew v-if="dataSource.type === TYPE_RADIO" :dataSource="item"
                                    :nameField="`answer_${dataSource.id}`" :location="indexanswers" :parent="dataSource"
                                    :valueSelected="item.correct" :answerContent="item.content"
                                    :statusUserExcercise="2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import MultipleChoiceNew from './../../../../question/preview-question/answers/multiple-choice/MultipleChoiceNew.vue'
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import { getDetailExcercise } from './../../../_api/LessonClassSchoolServices'
import { APP_CONFIG } from '@/utils/constants'
import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
export default {
    components: {
        MultipleChoiceNew,
        PreviewQuestion
    },
    data() {
        return {
            TYPE_RADIO: 'radio',
            TYPE_CHECKBOX: 'checkbox',
            TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
            TYPE_MATH_COL: 'math_col',
            TYPE_FILL_BLANK: 'fill_blank',
            TYPE_FILL_SENTENCE: 'fill_sentence',
            TYPE_SELECT: 'select',
            TYPE_DOWN_ANSWER: 'down_answer',
            TYPE_CIRCLE_ANSWER: 'circle_answer',
            TYPE_X_MARK: 'x_mark_answer',
            TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
            TYPE_GROUP: 'group',
            TYPE_FILL_INPUT_IMG: 'fill_input_img',
            dataDetailExcercise: {},
            lessonClassSchoolId: 0,
            examId: 0,
            apiUrl: APP_CONFIG.appUrl + 'lessons/',
        }
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    mounted() {
        this.lessonClassSchoolId = this.$route.query.lessonId
        this.examId = this.$route.query.examId
        this.getDetailLessonClassSchool()
    },
    methods: {
        getDetailLessonClassSchool() {
            let self = this
            getDetailExcercise(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataDetailExcercise = res.data

                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.wrap-page {
    width: 100%;
    height: 40rem;
    overflow: auto;
}

.item-question-answer {
    padding: 10px;
    background: #e1effe;
    border-radius: 10px;
    border: 1px solid #b1b1b1;
    margin-bottom: 10px;
}

.margin-top-10 {
    margin-top: 20px;
}

.full-width {
    width: 100%;
    height: 40rem;
}

.ember-pdf {
    width: 100%;
    height: inherit;
}
</style>